// @ts-nocheck
import React from 'react';
import KeyProviderLink from '../../common/links/KeyProviderLink';
import { useTranslation } from 'react-i18next';

export interface KeyProviderProps {
  request: Record<string, unknown>;
  compressed?: boolean;
}

const KeyProvider = ({ request, compressed }: KeyProviderProps) => {
  const { t } = useTranslation();

  return request && compressed ? (
    <KeyProviderLink
      id={request.keyProviderId}
      name={request.keyProviderName}
    />
  ) : (
    <div className="col-6">
      <label className="col-form-label">{t('Provider')}</label>
      <div className="flex ps-0">
        <div className="form-control-static px-3 flex h-100 w-100 align-items-center">
          <KeyProviderLink
            id={request.keyProviderId}
            name={request.keyProviderName}
          />
        </div>
      </div>
    </div>
  );
};

export default KeyProvider;
